<template>
  <section>
    <div class="table_top_div" style="padding-top: 0">
      <el-tabs style="width: 100%; font-size: 12px" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="2024年整体分析" name="1">
          <div>
            <el-row type="flex" justify="space-around">
              <el-col :span="7">
                <el-card style="background-color: #e7edff" class="card_cls" shadow="hover">
                  <div :style="{ color: '#3a5fc9', 'font-size': isMobile ? '14px' : '' }">总签约量</div>
                  <div :style="{ color: '#3a5fc9', 'margin-top': '10px', 'font-size': isMobile ? '18px' : '24px' }">
                    {{ currency(analysis_details.totalContractVolume) }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="7">
                <el-card style="background-color: #ffeeea" class="card_cls" shadow="hover">
                  <div :style="{ color: '#e97758', 'font-size': isMobile ? '14px' : '' }">总市场潜力</div>
                  <div :style="{ color: '#e97758', 'margin-top': '10px', 'font-size': isMobile ? '18px' : '24px' }">
                    {{ currency(analysis_details.totalMarketPotential) }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="7">
                <el-card style="background-color: #e7edff" class="card_cls" shadow="hover">
                  <div :style="{ color: '#3a5fc9', 'font-size': isMobile ? '14px' : '' }">上年份额</div>
                  <div :style="{ color: '#3a5fc9', 'margin-top': '10px', 'font-size': isMobile ? '18px' : '24px' }">
                    {{ analysis_details.lastYearShare * 100 + '%' }}
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div style="text-align: center; overflow-x: auto">
              <div id="ric_div" :style="style_tbs"></div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="报量达成率" name="2">
          <div>
            <el-form :inline="true">
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="achievementrate_form.startTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="开始时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="achievementrate_form.endTime"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-select clearable style="width: 140px" v-model="achievementrate_form.productId" placeholder="产品代码">
                  <el-option v-for="item in productlistothers_lsit" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getachievementrate_fn">查询</el-button>
              </el-form-item>
            </el-form>
            <!-- <div style="margin-left: 150px; margin-top: 10px"><div>华南报量达成率</div></div> -->
          </div>
          <!-- <div style="text-align: center; overflow-x: auto">
            <div id="achievementrate" :style="style_tbs"></div>
          </div> -->
          <div v-for="item in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; font-size: 16px; margin-top: 10px">报量达成率-{{ item.regionName }}</div>
            <div :id="'achievementrate' + item.regionId" :style="style_tbs2"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="日报量趋势" name="3">
          <div>
            <el-form inline>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="monthlystackeddata_form.yearMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="选择月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getmonthlystackeddata_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-for="item in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; font-size: 16px; margin-top: 10px">日报量趋势-{{ item.regionName }}</div>
            <div :id="'monthlystackeddata' + item.regionId" :style="style_tbs"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="日均植入量趋势" name="4">
          <div>
            <el-form inline>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="monthlyaverageimplantdata_form.startYearMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="开始时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="monthlyaverageimplantdata_form.endYearMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getmonthlyaverageimplantdata_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-for="item in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; font-size: 16px; margin-top: 10px">日均植入量趋势-{{ item.regionName }}</div>
            <div :id="'monthlyaverageimplantdata' + item.regionId" :style="style_tbs"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="片数份额（偏好度）" name="5">
          <div>
            <el-form inline>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="weeklysharedata_form.startYearMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="开始时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="weeklysharedata_form.endYearMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="weeklysharedata_form_startWeek"
                  type="week"
                  id="startWeek"
                  format="yyyy-WW周"
                  placeholder="起始周"
                  firstDayOfWeek="1"
                  :picker-options="weekOptions"
                  @change="startWeek_change"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="weeklysharedata_form_endWeek"
                  type="week"
                  id="endWeek"
                  format="yyyy-WW周"
                  value-format="yyyy-MM-dd"
                  placeholder="结束周"
                  :picker-options="weekOptions"
                  @change="endWeek_change"
                ></el-date-picker>
              </el-form-item> -->
              <el-form-item label="">
                <el-select clearable style="width: 140px" v-model="weeklysharedata_form.isPrivate" placeholder="公/私立医院">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="私立" :value="true"></el-option>
                  <el-option label="公立" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="大区">
                <el-select
                  clearable
                  @change="regionsbylevel_select($event, 'weeklysharedata')"
                  style="width: 140px"
                  v-model="weeklysharedata_form.regionalAreaId"
                  placeholder="请选择"
                >
                  <el-option v-for="item in regionsbylevel_list_select" :label="item.regionName" :value="item.regionId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="小区">
                <el-select clearable style="width: 140px" v-model="weeklysharedata_form.subRegionId" placeholder="请选择">
                  <el-option v-for="item in region_sub_list" :label="item.subRegionName" :value="item.subRegionId"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getweeklysharedata_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-for="item in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; font-size: 16px; margin-top: 10px">片数份额（偏好度）-{{ item.regionName }}</div>
            <div :id="'weeklysharedata' + item.regionId" :style="style_tbs"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="销量同比增长" name="6">
          <div>
            <el-form inline>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="monthlygrowthpercentage_form.startMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="起始月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="monthlygrowthpercentage_form.endMonth"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  type="month"
                  placeholder="结束月份"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="大区">
                <el-select
                  clearable
                  @change="regionsbylevel_select($event, 'monthlygrowthpercentage')"
                  style="width: 140px"
                  v-model="monthlygrowthpercentage_form.regionalAreaId"
                  placeholder="请选择"
                >
                  <el-option v-for="item in regionsbylevel_list_select" :label="item.regionName" :value="item.regionId"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="小区">
                <el-select style="width: 140px" v-model="contractprogress_form.subRegionId" placeholder="请选择">
                  <el-option v-for="item in region_sub_list" :label="item.subRegionName" :value="item.subRegionId"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="">
                <el-select clearable style="width: 140px" v-model="monthlygrowthpercentage_form.isPrivate" placeholder="公/私立医院">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="私立" :value="true"></el-option>
                  <el-option label="公立" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getmonthlygrowthpercentage_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-for="(item, index) in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; margin-top: 10px; margin-bottom: 0px; font-size: 16px">
              <div style="margin-bottom: 10px">产品销量占比</div>
              <div style="margin-bottom: 3px; margin-left: 16px" v-for="itemsas in productpercentage_details[index]">
                {{ itemsas.category }} :
                <span style="color: #00b4ff">{{ Number(itemsas.percentage * 100).toFixed(0) + '%' }}</span>
              </div>
            </div>
            <div style="margin-left: 5px; font-size: 16px; margin-top: 20px">销量同比增长-{{ item.regionName }}</div>
            <div :id="'monthlygrowthpercentage' + item.regionId" :style="style_tbs"></div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="产品销量占比" name="7">
          <div>
            <el-form inline>
              <el-form-item label="开始月份">
                <el-date-picker style="width: 140px" v-model="productpercentage_form.startTime" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="结束月份">
                <el-date-picker style="width: 140px" v-model="productpercentage_form.endTime" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="公/私立医院">
                <el-select style="width: 140px" v-model="productpercentage_form.isPrivate" placeholder="请选择">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="私立" :value="true"></el-option>
                  <el-option label="公立" :value="false"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="大区">
                <el-select style="width: 140px" v-model="productpercentage_form.regionalAreaId" placeholder="请选择"></el-select>
              </el-form-item>
              <el-form-item label="小区">
                <el-select style="width: 140px" v-model="productpercentage_form.subRegionId" placeholder="请选择"></el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getproductpercentage_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="text-align: center; overflow-x: auto">
            <div id="productpercentage" :style="style_tbs"></div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="报量准确性" name="8">
          <div>
            <el-form inline>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="productgroupaccuracy_form.startMonth"
                  type="month"
                  placeholder="开始月份"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-date-picker
                  :prefix-icon="isMobile ? '11' : ''"
                  style="width: 140px"
                  v-model="productgroupaccuracy_form.endMonth"
                  type="month"
                  placeholder="结束月份"
                ></el-date-picker>
              </el-form-item>
              <!-- <el-form-item label="大区">
                <el-select
                  clearable
                  @change="regionsbylevel_select($event, 'productgroupaccuracy')"
                  style="width: 140px"
                  v-model="productgroupaccuracy_form.regionalAreaId"
                  placeholder="请选择"
                >
                  <el-option v-for="item in regionsbylevel_list_select" :label="item.regionName" :value="item.regionId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="小区">
                <el-select clearable style="width: 140px" v-model="productgroupaccuracy_form.subRegionId" placeholder="请选择">
                  <el-option v-for="item in region_sub_list" :label="item.subRegionName" :value="item.subRegionId"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getproductgroupaccuracy_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- <div style="text-align: center; overflow-x: auto">
            <div id="productgroupaccuracy" :style="style_tbs"></div>
          </div> -->
          <div v-for="item in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; font-size: 16px; margin-top: 10px">报量准确性-{{ item.regionName }}</div>
            <div :id="'productgroupaccuracy' + item.regionId" :style="style_tbs"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="签约量进度" name="9">
          <div>
            <el-form inline>
              <!-- <el-form-item label="公/私立医院">
                <el-select style="width: 140px" v-model="weeklysharedata_form.isPrivate" placeholder="请选择">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="私立" :value="true"></el-option>
                  <el-option label="公立" :value="false"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="大区">
                <el-select
                  clearable
                  @change="regionsbylevel_select($event, 'contractprogress')"
                  style="width: 140px"
                  v-model="contractprogress_form.regionalAreaId"
                  placeholder="请选择"
                >
                  <el-option v-for="item in regionsbylevel_list_select" :label="item.regionName" :value="item.regionId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="小区">
                <el-select clearable style="width: 140px" v-model="contractprogress_form.subRegionId" placeholder="请选择">
                  <el-option v-for="item in region_sub_list" :label="item.subRegionName" :value="item.subRegionId"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="">
                <el-select clearable style="width: 140px" v-model="contractprogress_form.productId" placeholder="产品代码">
                  <el-option v-for="item in productlistothers_lsit" :label="item.code" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary" @click="dashboard_getcontractprogress_fn">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- <div style="text-align: center; overflow-x: auto">
            <div id="contractprogress" :style="style_tbs"></div>
          </div> -->
          <div v-for="item in regionsbylevel_list" :key="item.id" :style="isMobile ? 'overflow-x: auto' : ''">
            <div style="margin-left: 5px; font-size: 16px; margin-top: 10px">签约量进度-{{ item.regionName }}</div>
            <div :id="'contractprogress' + item.regionId" :style="style_tbs"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  dashboard_analysis,
  dashboard_getachievementrate,
  dashboard_getmonthlystackeddata,
  dashboard_getmonthlyaverageimplantdata,
  dashboard_getweeklysharedata,
  dashboard_getmonthlygrowthpercentage,
  dashboard_getproductpercentage,
  dashboard_getproductgroupaccuracy,
  dashboard_getcontractprogress,
  dashboard_getregionsbylevel,
  system_getproductlistothers,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'
import * as echarts from 'echarts'
export default {
  components: { Toolbar, quillEditor },
  computed: {
    style_tbs() {
      return {
        width: this.isMobile ? '1200px' : '100%',
        height: '400px',
        display: 'inline-block',
      }
    },
    style_tbs2() {
      return {
        width: this.isMobile ? '800px' : '100%',
        height: '400px',
        display: 'inline-block',
      }
    },
  },
  data() {
    return {
      weekOptions: {
        firstDayOfWeek: 1, // 设置周一为周的开始
      },
      region_sub_list: [],
      productlistothers_lsit: [],
      today_select: '',
      month_select: '',
      productpercentage_details: [],
      regionsbylevel_list: [],
      regionsbylevel_list_select: [],
      loading: {},
      monthlygrowthpercentage_form: {
        startMonth: '2024-01',
        endMonth: '2024-12',
      },
      productpercentage_form: {
        startTime: '2024-01-01',
        endTime: '2024-12-01',
      },
      productgroupaccuracy_form: {
        startMonth: '2024-01',
        endMonth: '2024-12',
      },
      contractprogress_form: {},
      weeklysharedata_form: {
        startYearMonth: '2024-01',
        endYearMonth: '2024-06',
      },
      monthlyaverageimplantdata_form: {
        startYearMonth: '2024-01',
        endYearMonth: '2024-12',
      },
      monthlystackeddata_form: {
        yearMonth: '2025-01',
      },
      achievementrate_form: {
        startTime: '2024-01-01',
        endTime: '2024-12-01',
      },
      analysis_details: {},
      activeName: '1',
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      weeklysharedata_form_startWeek: '',
      weeklysharedata_form_endWeek: '',
    }
  },
  methods: {
    getWeekNumber() {
      const now = new Date()
      const oneJan = new Date(now.getFullYear(), 0, 1)
      const pastDays = (now - oneJan) / 86400000
      return Math.ceil((pastDays + oneJan.getDay() + 1) / 7)
    },
    endWeek_change(value, dateString) {
      let wekks = ''
      this.$nextTick(() => {
        wekks = document.querySelector('#endWeek').value
        this.weeklysharedata_form.endWeek = wekks
      })

      console.log(this.weeklysharedata_form.endWeek)
    },
    startWeek_change(value, dateString) {
      console.log(value)
      let wekks = ''
      this.$nextTick(() => {
        wekks = document.querySelector('#startWeek').value
        this.weeklysharedata_form.startWeek = wekks
      })
    },
    regionsbylevel_select(e, name) {
      if (this[name + '_form'].subRegionId) {
        this[name + '_form'].subRegionId = ''
      }
      this.region_sub_list = this.regionsbylevel_list_select.filter((item) => item.regionId == e)[0].subRegions
      console.log(this.region_sub_list)
    },
    calculateSum(e) {
      //dataString是整数，否则要parseInt转换
      var time = new Date()
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      var hour = time.getHours()
      var minute = time.getMinutes()
      var second = time.getSeconds()
      if (Number(month) + 1 == 13) {
        var old_month = 1
        var old_year = year
      } else {
        var old_month = month + 1
        var old_year = year - 1
      }
      let today_select = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      let month_select = year + '-' + (Number(month) < 10 ? '0' + month : month)
      let month_one = year + '-' + (Number(month) < 10 ? '0' + month : month) + '-' + '01'
      let old_year_month = old_year + '-' + (Number(old_month) < 10 ? '0' + old_month : old_month)
      let new_year_month = year + '-' + '12'
      let mid_year_month = year + '-' + '06'
      let now_year_month = year + '-' + '01'
      if (e == 1) {
        return today_select
      } else if (e == 2) {
        return month_one
      } else if (e == 3) {
        return old_year_month
      } else if (e == 4) {
        return new_year_month
      } else if (e == 5) {
        return now_year_month
      } else if (e == 6) {
        return mid_year_month
      } else {
        return month_select
      }
      //   return (
      //     year +
      //     '-' +
      //     (month < 10 ? '0' + month : month) +
      //     '-' +
      //     (day < 10 ? '0' + day : day) +
      //     ' ' +
      //     (hour < 10 ? '0' + hour : hour) +
      //     ':' +
      //     (minute < 10 ? '0' + minute : minute) +
      //     ':' +
      //     (second < 10 ? '0' + second : second)
      //   )
    },
    currency(val) {
      if (val == '' || val == null) {
        return val
      }
      if (Number(val) == 0) {
        return 0
      }
      let precision = 0
      let decimal = this.checkNaN(val, (v) => v.toFixed(precision))
      const [n, d = []] = decimal.toString().split('.')
      return [n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')].concat(d).join('.')
      //   }
    },
    checkNaN(value, cb) {
      const val = parseFloat(value)
      return isNaN(val) ? undefined : cb(val)
    },
    // 产品份额占比
    ric_div_fn(res) {
      var chartDom = document.getElementById('ric_div')
      var myChart = echarts.init(chartDom)
      let xAxis_name = []
      let yAxis_num = []
      for (let i in res.productShares) {
        xAxis_name.push(res.productShares[i].name)
        yAxis_num.push(res.productShares[i].value)
        // amountAchievementRate_list.push(res[i].amountAchievementRate)
      }
      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'

              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      var option
      option = {
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        xAxis: {
          type: 'category',
          data: xAxis_name,
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
          axisLabel: {
            formatter: (value) => {
              return value * 100 + '%'
            },
          },
        },
        series: [
          {
            data: yAxis_num,
            itemStyle: itemStyle_cls,
            type: 'bar',
          },
        ],
      }
      //   option = {
      //     tooltip: {
      //       trigger: 'item',
      //       formatter: function (params) {
      //         // 假设 params 是一个数组，每个元素是一个系列的数据信息
      //         // 对每个数据项格式化，显示两位小数
      //         // res = params.name + ': ' + (params.value == null ? '-' : (params.value * 100).toFixed(0) + '%')

      //         return params.name + ': ' + params.value
      //       },
      //     },
      //     legend: {
      //       bottom: '0%',
      //       //   right: '5%',
      //       width: 300,
      //       //   itemGap: 50,
      //       //   left: 'center',
      //       data: res.productShares,
      //     },
      //     color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
      //     series: [
      //       {
      //         // name: 'productName',
      //         // value: 'sharePercentage',
      //         type: 'pie',
      //         // radius: ['40%', '70%'],
      //         avoidLabelOverlap: false,
      //         label: {
      //           show: false,
      //           position: 'center',
      //           normal: {
      //             show: true,
      //             formatter: '{b}: {d}%',
      //           },
      //         },
      //         emphasis: {
      //           label: {
      //             show: true,
      //             fontSize: 40,
      //             fontWeight: 'bold',
      //           },
      //         },
      //         labelLine: {
      //           show: false,
      //         },
      //         data: res.productShares,
      //       },
      //     ],
      //   }
      option && myChart.setOption(option) //通过setOption()方法生成图表
    },
    // 报量达成率
    achievementrate_div_fn(res, id) {
      let date_list = []
      let products_name = []
      let products_name_new = []
      let xAxis_name = []
      let achievementRate_list = []
      let amountAchievementRate_list = []
      console.log(res)
      var ids_name = ''
      if (id == '') {
        ids_name = 'achievementrate'
      } else {
        ids_name = 'achievementrate' + id
      }

      for (let i in res) {
        xAxis_name.push(res[i].category)
        achievementRate_list.push(res[i].achievementRate)
        amountAchievementRate_list.push(res[i].amountAchievementRate)
      }
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      var option
      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'
              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      option = {
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        // tooltip: {
        //   trigger: 'axis',
        //   axisPointer: {
        //     type: 'shadow',
        //   },
        // },
        legend: {
          bottom: '0%',
          width: 300,
          data: ['片数', '金额'],
        },
        color: ['#95c6ff', '#f99d84', '#8f55f3'],
        xAxis: {
          type: 'category',
          data: xAxis_name,
        },
        yAxis: {
          type: 'value',
          min: 0,
          //   max: 1,
          axisLabel: {
            formatter: (value) => {
              return value * 100 + '%'
            },
          },
        },
        series: [
          {
            name: '片数',
            type: 'bar',
            barWidth: '30',
            itemStyle: itemStyle_cls,
            data: achievementRate_list,
          },
          {
            name: '金额',
            type: 'bar',
            barWidth: '30',
            itemStyle: itemStyle_cls,
            data: amountAchievementRate_list,
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 日报量趋势
    monthlystackeddata_div_fn(res, id) {
      let date_list = []
      let products_name = []
      let products_name_new = []
      console.log(res)
      var ids_name = ''
      if (id == '') {
        ids_name = 'monthlystackeddata'
      } else {
        ids_name = 'monthlystackeddata' + id
      }
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      for (let i in res) {
        date_list.push(res[i].date)
      }
      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              var yAxisScale = myChart.getModel().getComponent('yAxis', 0).axis.scale
              var yAxismaxnum = yAxisScale._extent[1]
              //   let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'
              if (params.value / yAxismaxnum > 0.02) {
                return params.value.toFixed(0)
              } else {
                return ''
              }
            },
            show: true,
            position: 'inside', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: 'black',
              fontSize: 12,
            },
          },
        },
      }
      res[0].products.filter((item) => {
        if (item.productName != 'Summary') {
          products_name_new.push(item.productName)
        }
        products_name.push(item.productName)
      })
      console.log(products_name)
      var option
      const series = products_name.map((name, sid) => {
        if (name == 'Summary') {
          return {
            name: 'Summary', // 总数显示，生成一个总数的柱状图，将颜色设为透明，
            type: 'bar', // label将位置设备内部底部，造成一个总数显示在
            stack: 'zs', // 柱状图上方的假象
            barWidth: '30',
            barGap: '-100%',
            label: {
              normal: {
                position: 'top',
                show: true,
                formatter: function (params) {
                  return params.value.toFixed(0)
                },
                textStyle: {
                  color: '#00b4ff',
                  // fontSize: 14, fontWeight: 'bold'
                },
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(0,0,0,0)', // 柱状图颜色设为透明
              },
            },
            data: res.map((d, did) => {
              return d.products[sid].actualVolume
            }),
          }
        }
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '30',
          itemStyle: itemStyle_cls,
          data: res.map((d, did) => {
            return d.products[sid].actualVolume
          }),
        }
      })
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          //   formatter: function (params) {
          //     console.log(params.seriesName)
          //     return params.seriesName + ': ' + params.value
          //   },
        },
        legend: {
          bottom: '0%',
          //   right: '5%',
          width: 600,
          data: products_name_new,
        },
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
        xAxis: {
          type: 'category',
          data: date_list,
          axisLabel: {
            interval: 0,
            rotate: 30,
            // formatter: function (value) {
            //   return value.split('').join('\n') //垂直显示
            // },
          },
        },
        yAxis: {
          type: 'value',
          //   min: 0,
          //   max: 100,
          //   axisLabel: {
          //     formatter: (value) => {
          //       return value + '%'
          //     },
          //   },
        },
        series: series,
      }
      option && myChart.setOption(option)
    },
    // 日均植入量趋势
    monthlyaverageimplantdata_div_fn(res, id) {
      let date_list = []
      let products_name = []
      let products_name_new = []
      console.log(res)
      var ids_name = ''
      if (id == '') {
        ids_name = 'monthlyaverageimplantdata'
      } else {
        ids_name = 'monthlyaverageimplantdata' + id
      }
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      for (let i in res) {
        date_list.push(res[i].month)
      }
      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              var yAxisScale = myChart.getModel().getComponent('yAxis', 0).axis.scale
              var yAxismaxnum = yAxisScale._extent[1]
              //   let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'
              if (params.value / yAxismaxnum > 0.02) {
                return params.value.toFixed(0)
              } else {
                return ''
              }
            },
            show: true,
            position: 'inside', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: 'black',
              fontSize: 12,
            },
          },
        },
      }
      res[0].products.filter((item) => {
        if (item.productName != 'Summary') {
          products_name_new.push(item.productName)
        }
        products_name.push(item.productName)
      })
      var option
      const series = products_name.map((name, sid) => {
        if (name == 'Summary') {
          return {
            name: 'Summary', // 总数显示，生成一个总数的柱状图，将颜色设为透明，
            type: 'bar', // label将位置设备内部底部，造成一个总数显示在
            stack: 'zs', // 柱状图上方的假象
            barWidth: '30',
            barGap: '-100%',
            label: {
              normal: {
                position: 'top',
                show: true,
                formatter: function (params) {
                  return params.value.toFixed(0)
                },
                textStyle: {
                  color: '#00b4ff',
                  // fontSize: 14, fontWeight: 'bold'
                },
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(0,0,0,0)', // 柱状图颜色设为透明
              },
            },
            data: res.map((d, did) => {
              return d.products[sid].monthlyAverageVolume
            }),
          }
        }
        return {
          name,
          type: 'bar',
          stack: 'total',
          barWidth: '30',
          itemStyle: itemStyle_cls,
          data: res.map((d, did) => {
            return d.products[sid].monthlyAverageVolume
          }),
        }
      })
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          //   formatter: function (params) {
          //     console.log(params.seriesName)
          //     return params.seriesName + ': ' + params.value
          //   },
        },
        legend: {
          bottom: '0%',
          //   right: '5%',
          width: 600,
          data: products_name_new,
        },
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
        xAxis: {
          type: 'category',
          data: date_list,
          axisLabel: {
            interval: 0,
            rotate: 30,
            // formatter: function (value) {
            //   return value.split('').join('\n') //垂直显示
            // },
          },
        },
        yAxis: {
          type: 'value',
          //   min: 0,
          //   max: 100,
          //   axisLabel: {
          //     formatter: (value) => {
          //       return value + '%'
          //     },
          //   },
        },
        series: series,
      }
      option && myChart.setOption(option)
    },
    // 片数份额
    weeklysharedata_div_fn(res, id) {
      //   let date_list = []
      let products_name = []
      let products_name_new = []
      var ids_name = ''
      if (id == '') {
        ids_name = 'weeklysharedata'
      } else {
        ids_name = 'weeklysharedata' + id
      }

      //   for (let i in res) {
      //     date_list.push(res[i].month)
      //   }
      let xAxis_name = []
      let achievementRate_list = []
      let amountAchievementRate_list = []
      for (let i in res) {
        xAxis_name.push(res[i].month)
        achievementRate_list.push(res[i].achievementRate)
        amountAchievementRate_list.push(res[i].amountAchievementRate)
      }
      res[0].categories.filter((item) => {
        products_name.push(item.category)
      })
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      var option

      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'

              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      let series_list = products_name.map((name, sid) => {
        return {
          name: name,
          type: 'bar',
          //   barCategoryGap: '20',
          itemStyle: itemStyle_cls,
          data: res.map((d, did) => {
            return d.categories[sid].share
          }),
        }
      })
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            console.log(params)
            var str = ''
            for (let item of params) {
              str += item.marker += item.seriesName + ' : ' + (item.value * 100).toFixed(0) + '%<br>'
            }
            return str
          },
        },
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        legend: {
          bottom: '0%',
          //   right: '5%',
          width: 600,
          data: products_name,
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3', '#1d953f'],
        xAxis: {
          type: 'category',
          data: xAxis_name,
          axisLabel: {
            interval: 0,
            rotate: 30,
            // formatter: function (value) {
            //   return value.split('').join('\n') //垂直显示
            // },
          },
        },
        yAxis: {
          type: 'value',
          //   min: 0,
          //   max: 100,
          axisLabel: {
            formatter: (value) => {
              return value * 100 + '%'
            },
          },
        },
        series: series_list,
      }
      option && myChart.setOption(option)
    },
    // 同比增长
    monthlygrowthpercentage_div_fn(res, id) {
      let products_name_new = []
      var ids_name = ''
      if (id == '') {
        ids_name = 'monthlygrowthpercentage'
      } else {
        ids_name = 'monthlygrowthpercentage' + id
      }
      let xAxis_name = []
      let achievementRate_list = []
      let amountAchievementRate_list = []
      let products_name = []
      for (let i in res) {
        xAxis_name.push(res[i].month)
        // achievementRate_list.push(res[i].achievementRate)
        // amountAchievementRate_list.push(res[i].amountAchievementRate)
      }
      res[0].categories.filter((item) => {
        products_name.push(item.category)
      })
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      var option

      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'

              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      let series_list = products_name.map((name, sid) => {
        return {
          name: name,
          type: 'bar',
          //   barWidth: '30',
          itemStyle: itemStyle_cls,
          data: res.map((d, did) => {
            return d.categories[sid].growthPercentage
          }),
        }
      })
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            console.log(params)
            var str = ''
            for (let item of params) {
              str += item.marker += item.seriesName + ' : ' + (item.value * 100).toFixed(0) + '%<br>'
            }
            return str
          },
        },
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        legend: {
          bottom: '0%',
          //   right: '5%',
          width: 600,
          data: products_name,
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
        // xAxis: {
        //   type: 'category',
        //   data: xAxis_name,
        // },
        xAxis: {
          type: 'category',
          data: xAxis_name,
          axisLabel: {
            interval: 0,
            rotate: 30,
            // formatter: function (value) {
            //   return value.split('').join('\n') //垂直显示
            // },
          },
        },
        yAxis: {
          type: 'value',
          //   min: 0,
          //   max: 100,
          axisLabel: {
            formatter: (value) => {
              return value * 100 + '%'
            },
          },
        },
        series: series_list,
      }
      option && myChart.setOption(option)
    },
    // 产品占比
    productpercentage_div_fn(res) {
      //   return
      let xAxis_name = []
      let percentage_list = []
      for (let i in res) {
        xAxis_name.push(res[i].category)
        percentage_list.push(res[i].percentage)
      }
      var chartDom = document.getElementById('productpercentage')
      var myChart = echarts.init(chartDom)
      var option

      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'

              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          bottom: '0%',
          //   right: '5%',
          width: 600,
          data: xAxis_name,
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
        xAxis: {
          type: 'category',
          data: xAxis_name,
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
          axisLabel: {
            formatter: (value) => {
              return value * 100 + '%'
            },
          },
        },
        series: [
          {
            data: percentage_list,
            type: 'bar',
            itemStyle: itemStyle_cls,
          },
        ],
      }
      option && myChart.setOption(option)
    },
    // 报量准确性
    productgroupaccuracy_div_fn(res, id) {
      let products_name_new = []
      var ids_name = ''
      if (id == '') {
        ids_name = 'productgroupaccuracy'
      } else {
        ids_name = 'productgroupaccuracy' + id
      }
      //   return
      let xAxis_name = []
      let products_name = []
      let percentage_list = [1, 2, 3, 4]
      for (let i in res) {
        xAxis_name.push(res[i].month)
      }
      res[0].data.filter((item) => {
        products_name.push(item.category)
      })
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      var option

      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'

              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      let series_list = products_name.map((name, sid) => {
        return {
          name: name,
          type: 'bar',
          itemStyle: itemStyle_cls,
          data: res.map((d, did) => {
            return d.data[sid].accuracyPercentage
          }),
        }
      })
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            console.log(params)
            var str = ''
            for (let item of params) {
              str += item.marker += item.seriesName + ' : ' + (item.value * 100).toFixed(0) + '%<br>'
            }
            return str
          },
        },
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        legend: {
          bottom: '0%',
          //   right: '5%',
          width: 600,
          data: products_name,
        },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
        xAxis: {
          type: 'category',
          data: xAxis_name,
        },
        yAxis: {
          type: 'value',
          //   min: 0,
          //   max: 100,
          //   axisLabel: {
          //     formatter: (value) => {
          //       return value + '%'
          //     },
          //   },
        },
        series: series_list,
      }
      option && myChart.setOption(option)
    },
    // 签约量进度
    contractprogress_div_fn(res, id) {
      let products_name_new = []
      var ids_name = ''
      if (id == '') {
        ids_name = 'contractprogress'
      } else {
        ids_name = 'contractprogress' + id
      }
      let xAxis_name = []
      let freeVolume_list = []
      let progressPercentage_list = []
      for (let i in res) {
        xAxis_name.push(res[i].category)
        freeVolume_list.push(res[i].freeVolume)
        progressPercentage_list.push(res[i].progressPercentage)
      }
      var chartDom = document.getElementById(ids_name)
      //   return
      var myChart = echarts.init(chartDom)
      var option
      let itemStyle_cls = {
        normal: {
          label: {
            formatter: function (params) {
              let itemsname = params.value == null ? '-' : (params.value * 100).toFixed(0) + '%'

              return itemsname
            },
            show: true, //关键点开启显示
            position: 'top', //top上方;left左侧;right右方显示
            textStyle: {
              //数值样式
              color: '#00b4ff',
              fontSize: 12,
            },
          },
        },
      }
      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params) {
            let itemsname =
              params[0].name +
              ': ' +
              (params[0].value == null ? '-' : (params[0].value * 100).toFixed(0) + '%') +
              '<br>' +
              '片数' +
              ': ' +
              res[params[0].dataIndex].freeVolume
            return itemsname
          },
        },
        grid: {
          left: '48px', // 将图表的左边距设置为容器宽度的5%
          bottom: '80px',
          right: '50px',
          top: '20px',
          // 其他 grid 属性根据需要设置
        },
        // legend: {
        //   data: ['金额'],
        // },
        color: ['#95c6ff', '#3a5fc9', '#f99d84', '#8f55f3'],
        xAxis: {
          type: 'category',
          data: xAxis_name,
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 1,
          axisLabel: {
            formatter: (value) => {
              return value * 100 + '%'
            },
          },
        },
        series: [
          //   {
          //     name: '片数',
          //     type: 'bar',
          //     itemStyle: itemStyle_cls,
          //     data: freeVolume_list,
          //   },
          {
            name: '金额',
            type: 'bar',
            itemStyle: itemStyle_cls,
            data: progressPercentage_list,
          },
        ],
      }
      option && myChart.setOption(option)
    },
    async dashboard_analysis_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      const { data } = await dashboard_analysis()
      if (data.code == 200) {
        this.ric_div_fn(data.data)
        this.analysis_details = data.data
      }
      this.loading.close()
    },

    async dashboard_getachievementrate_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      //   const { data } = await dashboard_getachievementrate(this.achievementrate_form)
      let regionsbylevel_list = this.regionsbylevel_list
      let achievementrate_form = this.achievementrate_form
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        achievementrate_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getachievementrate(achievementrate_form)
        if (data.code == 200) {
          this.achievementrate_div_fn(data.data, regionsbylevel_list[i].regionId)
        }
        // this.loading.close()
      }
      this.loading.close()
      //   if (data.code == 200) {
      //     this.achievementrate_div_fn(data.data)
      //   }
      //   this.achievementrate_details = data.data
      //   this.loading.close()
    },
    async dashboard_getmonthlystackeddata_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      let regionsbylevel_list = this.regionsbylevel_list
      let monthlystackeddata_form = this.monthlystackeddata_form
      //   const { data } = await dashboard_getmonthlystackeddata(monthlystackeddata_form)
      //   if (data.code == 200) {
      //     this.monthlystackeddata_div_fn(data.data, '')
      //   }
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        monthlystackeddata_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getmonthlystackeddata(monthlystackeddata_form)
        if (data.code == 200) {
          this.monthlystackeddata_div_fn(data.data, regionsbylevel_list[i].regionId)
        }
        this.loading.close()
      }
    },
    async dashboard_getmonthlyaverageimplantdata_fn() {
      //   const { data } = await dashboard_getmonthlyaverageimplantdata(this.monthlyaverageimplantdata_form)
      //   if (data.code == 200) {
      //     this.monthlyaverageimplantdata_div_fn(data.data)
      //   }
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      let regionsbylevel_list = this.regionsbylevel_list
      let monthlyaverageimplantdata_form = this.monthlyaverageimplantdata_form
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        monthlyaverageimplantdata_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getmonthlyaverageimplantdata(monthlyaverageimplantdata_form)
        if (data.code == 200) {
          this.monthlyaverageimplantdata_div_fn(data.data, regionsbylevel_list[i].regionId)
        }
        // this.loading.close()
      }
      this.loading.close()
    },
    async dashboard_getweeklysharedata_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      await this.endWeek_change()
      await this.startWeek_change()
      let regionsbylevel_list = this.regionsbylevel_list
      let weeklysharedata_form = this.weeklysharedata_form
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        weeklysharedata_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getweeklysharedata(weeklysharedata_form)
        if (data.code == 200) {
          this.weeklysharedata_div_fn(data.data, regionsbylevel_list[i].regionId)
        }
        // this.loading.close()
      }
      //   const { data } = await dashboard_getweeklysharedata(this.weeklysharedata_form)
      //   if (data.code == 200) {
      //     this.weeklysharedata_div_fn(data.data)
      //   }
      this.loading.close()
    },
    async dashboard_getmonthlygrowthpercentage_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      let regionsbylevel_list = this.regionsbylevel_list
      let monthlygrowthpercentage_form = this.monthlygrowthpercentage_form
      this.productpercentage_details = []
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        monthlygrowthpercentage_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getmonthlygrowthpercentage(monthlygrowthpercentage_form)
        if (data.code == 200) {
          this.monthlygrowthpercentage_div_fn(data.data, regionsbylevel_list[i].regionId)
          this.dashboard_getproductpercentage_fn(regionsbylevel_list[i].regionId)
        }
        // this.loading.close()
      }
      //   const { data } = await dashboard_getmonthlygrowthpercentage(this.monthlygrowthpercentage_form)
      //   if (data.code == 200) {
      //     this.monthlygrowthpercentage_div_fn(data.data)
      //   }
      this.loading.close()
    },
    async dashboard_getproductpercentage_fn(id) {
      //   this.loading = this.$loading({
      //     lock: true,
      //     text: 'loading......',
      //   })
      let productpercentage_form = {
        startMonth: this.monthlygrowthpercentage_form.startMonth,
        endMonth: this.monthlygrowthpercentage_form.endMonth,
        isPrivate: this.monthlygrowthpercentage_form.isPrivate,
        regionalArea: id,
      }
      const { data } = await dashboard_getproductpercentage(productpercentage_form)
      //   if (data.code == 200) {
      //     this.productpercentage_div_fn(data.data)
      //   }
      this.productpercentage_details.push(data.data)
      console.log(this.productpercentage_details)
      //   this.loading.close()
    },
    async dashboard_getproductgroupaccuracy_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      let regionsbylevel_list = this.regionsbylevel_list
      let productgroupaccuracy_form = this.productgroupaccuracy_form
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        productgroupaccuracy_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getproductgroupaccuracy(productgroupaccuracy_form)
        if (data.code == 200) {
          this.productgroupaccuracy_div_fn(data.data, regionsbylevel_list[i].regionId)
        }
        // this.loading.close()
      }
      //   const { data } = await dashboard_getproductgroupaccuracy(this.productgroupaccuracy_form)
      //   if (data.code == 200) {
      //     this.productgroupaccuracy_div_fn(data.data)
      //   }
      this.loading.close()
    },
    async dashboard_getcontractprogress_fn() {
      this.loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      let regionsbylevel_list = this.regionsbylevel_list
      let contractprogress_form = this.contractprogress_form
      for (var i in regionsbylevel_list) {
        // console.log(this.regionsbylevel_list)
        contractprogress_form.regionalAreaId = regionsbylevel_list[i].regionId
        const { data } = await dashboard_getcontractprogress(contractprogress_form)
        if (data.code == 200) {
          this.contractprogress_div_fn(data.data, regionsbylevel_list[i].regionId)
        }
        // this.loading.close()
      }
      //   const { data } = await dashboard_getcontractprogress(this.contractprogress_form)
      //   if (data.code == 200) {
      //     this.contractprogress_div_fn(data.data)
      //   }
      this.loading.close()
    },
    handleClick(tab, event) {
      var name = tab.name
      switch (name) {
        case '1':
          this.dashboard_analysis_fn()
          break
        case '2':
          this.dashboard_getachievementrate_fn()
          break
        case '3':
          this.dashboard_getmonthlystackeddata_fn()
          break
        case '4':
          this.dashboard_getmonthlyaverageimplantdata_fn()
          break
        case '5':
          this.dashboard_getweeklysharedata_fn()
          break
        case '6':
          this.dashboard_getmonthlygrowthpercentage_fn()
          //   this.dashboard_getproductpercentage_fn()
          break
        case '7':
          this.dashboard_getproductpercentage_fn()
          break
        case '8':
          this.dashboard_getproductgroupaccuracy_fn()
          break
        case '9':
          this.dashboard_getcontractprogress_fn()
          break
      }
      console.log(tab.name, event)
    },
    async dashboard_getregionsbylevel_fn() {
      const { data } = await dashboard_getregionsbylevel()
      this.regionsbylevel_list_select = data.data.regions
      this.regionsbylevel_list = JSON.parse(JSON.stringify(data.data.regions))
      this.regionsbylevel_list.unshift({
        regionId: null,
        regionName: '全国',
      })
    },
    // 获取产品
    async system_getproductlistothers_fn() {
      const { data } = await system_getproductlistothers()
      this.productlistothers_lsit = data.data
      console.log(this.productlistothers_lsit)
    },
    getLastFourWeeksFirstDay() {
      const now = new Date()
      const firstDayOfLastFourWeeks = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 21)
      return firstDayOfLastFourWeeks
    },
    getWeeksInYear(year) {
      const d = new Date(year, 11, 31)
      return d.getWeek()
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 475
    console.log(window.innerWidth)
    this.dashboard_analysis_fn()
    this.dashboard_getregionsbylevel_fn()
    this.system_getproductlistothers_fn()
    // this.dashboard_getachievementrate_fn()
    // this.dashboard_getmonthlystackeddata_fn()
    // this.dashboard_getmonthlyaverageimplantdata_fn()
    // this.dashboard_getweeklysharedata_fn()
    // this.dashboard_getmonthlygrowthpercentage_fn()
    // this.dashboard_getproductpercentage_fn()
    // this.dashboard_getproductgroupaccuracy_fn()
    // this.dashboard_getcontractprogress_fn()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    this.monthlygrowthpercentage_form.startMonth = this.calculateSum(5)
    this.monthlygrowthpercentage_form.endMonth = this.calculateSum(6)
    // this.productpercentage_form.startTime = this.calculateSum(5)
    // this.productpercentage_form.endTime = this.calculateSum(6)
    this.productgroupaccuracy_form.startMonth = this.calculateSum(5)
    this.productgroupaccuracy_form.endMonth = this.calculateSum(6)
    this.monthlyaverageimplantdata_form.startYearMonth = this.calculateSum(5)
    this.monthlyaverageimplantdata_form.endYearMonth = this.calculateSum(4)
    this.monthlystackeddata_form.yearMonth = this.calculateSum()
    this.achievementrate_form.startTime = this.calculateSum(2)
    this.achievementrate_form.endTime = this.calculateSum(1)
    this.weeklysharedata_form.startYearMonth = this.calculateSum(5)
    this.weeklysharedata_form.endYearMonth = this.calculateSum(6)
  },
}
</script>
``
<style>
.card_cls div {
  text-align: center;
}
.el-tabs__item {
  font-size: 13px !important;
}
.el-tabs__header {
  margin: 0 0 5px !important;
}
</style>
